module.exports = __webpack_public_path__ + "img/202312_06.1c191ce6.jpg";